(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    class TextTruncateComponent extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[ref="truncateContent"]');
      const toggleButton = this.querySelector('[ref="truncateToggle"]');

      if (!content || !toggleButton) return;

      this.content = content;
      this.toggleButton = toggleButton;

      this.toggleButton.addEventListener('click', () => {
        const expanded = this.getAttribute('data-expanded') !== 'true';
        this.setAttribute('data-expanded', String(expanded));
        this.toggleButton.setAttribute('aria-expanded', String(expanded));
      });

      requestAnimationFrame(() => this.updateVisibility());
      window.addEventListener('resize', () => this.updateVisibility());
    }

    updateVisibility() {
      if (this.getAttribute('data-expanded') === 'true') return;
      this.toggleButton.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
    }
  }

  if (!customElements.get('text-truncate-component')) {
    customElements.define('text-truncate-component', TextTruncateComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
